import { DOCUMENT } from '@angular/common';
import {
  Component,
  OnInit,
  ElementRef,
  Inject,
  ViewEncapsulation,
  Input
} from '@angular/core';

@Component({
  selector: 'app-time-bar',
  templateUrl: './time-bar.component.html',
  styleUrls: ['./time-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TimeBarComponent implements OnInit {

  @Input() selectedHour: string;

  constructor(
    private elementRef: ElementRef,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    let timeDivision = 18;
    let time = 0;

    // mark bars
    for (let i = 0; i <= 60; i++) {
      const span = this.document.createElement('span');
      span.className = 'step-border';
      const child = this.document.createElement('div');
      child.className = 'step';
      child.setAttribute('data-time', `${time}`);
      child.appendChild(span);
      var stepsBar = this.elementRef.nativeElement.querySelector('.steps-bar');
      stepsBar.appendChild(child);
      time = time + timeDivision;
    }

    let markTimeDivision = 360;

    // mark time intervals
    for (let i = 0; i <= 12; i++) {
      const time = this.toDuration(Math.round(markTimeDivision * i) - 60 * i);
      const fullHour = ('0' + (Number(this.selectedHour) + 1).toString()).slice(-2);
      const pos = i * 5 + 1;
      const step = this.elementRef.nativeElement.querySelector(
        `.step:nth-child(${pos})`
      );
      const span = this.document.createElement('span');
      span.className = 'time-instant';
      span.innerText = time == 60 ? `${fullHour}:00` : `${this.selectedHour}:${time}`;
      step.appendChild(span);
    }
  }

  toDuration(sec_num: number) {
    if (sec_num === 3600) {
      return '60';
    }

    let hours: any = Math.floor(sec_num / 3600);
    let minutes: any = Math.round((sec_num - hours * 3600) / 60);
    let seconds: any = sec_num - hours * 3600 - minutes * 60;
    if (hours < 10) {
      hours = '0' + Math.round(hours);
    }
    if (minutes < 10) {
      minutes = '0' + Math.round(minutes);
    }
    if (seconds < 10) {
      seconds = '0' + Math.round(seconds);
    }
    const time =
      hours === '00' ? minutes : hours + ':' + minutes + ':' + seconds;
    return time;
  }
}
